import exportFromJSON from "export-from-json";

const exportarTabela = (titulo, data) => {
  const fileName = titulo;
  const exportType = exportFromJSON.types.csv;
  if (data) exportFromJSON({ data, fileName, exportType });
};

export default exportarTabela;